import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import { getFlightItemsView } from 'checkout/selectors/view/flights'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/promoMappers'
import getLoyaltyEarnKeyFromFlightItems from 'loyalty/lib/pointsCalculation/earnKey/getLoyaltyEarnKeyFromFlightItems'

const getCheckoutFlightsPointsCalculationRequests = createSelector(
  (state: App.State) => getFlightItemsView(state),
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (state: App.State) => state.geo.airports,
  (flightsViews, loyaltyPointsBonusResultV1): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!flightsViews.hasRequiredData) return EmptyArray
    const pointsCalculationRequests: Array<App.LoyaltyPointsEarnCalculationRequest> = []

    flightsViews.data.forEach((itemView) => {
      if (!itemView.loyalty.productType) return

      const earnKey = getLoyaltyEarnKeyFromFlightItems(itemView.flights, itemView.loyalty.productType)

      pointsCalculationRequests.push({
        price: itemView.totals.price,
        loyaltyProductType: itemView.loyalty.productType,
        itemId: itemView.item.itemId,
        promoKey: getPromoKeyForLoyaltyItem(loyaltyPointsBonusResultV1, { filter: { itemId: itemView.item.itemId } }),
        earnKey,
        offerId: itemView.item.flights[0]?.journeyId ?? '',
        packageId: '',
      })
    })

    return pointsCalculationRequests
  },
)

export default getCheckoutFlightsPointsCalculationRequests
